import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IApplicationWindow } from "src/app/shared/models/application-window.model";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: 'root' })
export class ApplicationWindowRepository {
  
    private readonly applicationWindowUrl: string = `${environment.apiUrl}/application-windows`;
  
    constructor(private http: HttpClient) { }

    public getActiveApplicationWindows(applicationType?: string): Observable<Array<IApplicationWindow>> {
        return this.http.get<Array<IApplicationWindow>>(this.applicationWindowUrl, {
            params: {
                ...(applicationType && {applicationType})
            }
        });
    }

    public getApplicationWindowByAcyrCode(acyrCode: string): Observable<Array<IApplicationWindow>> {
        return this.http.get<Array<IApplicationWindow>>(`${this.applicationWindowUrl}/windows-by-acyr-code/${acyrCode}`, {});
    }

    public getApplicationWindowByTypeAndAcyrCode(type: string, acyrCode: string): Observable<IApplicationWindow> {
        return this.http.get<IApplicationWindow>(`${this.applicationWindowUrl}/window-by-type-and-acyr-code/${type}/${acyrCode}`, {});
    }

    public updateApplicationWindows(acyrCode: string, applicationWindows: Array<IApplicationWindow>): Observable<Array<IApplicationWindow>> {
        return this.http.put<Array<IApplicationWindow>>(`${this.applicationWindowUrl}/${acyrCode}`, applicationWindows);
    }

    public createApplicationWindows(acyrCode: string, applicationWindows: Array<IApplicationWindow>): Observable<Array<IApplicationWindow>> {
        return this.http.post<Array<IApplicationWindow>>(`${this.applicationWindowUrl}/${acyrCode}`, applicationWindows);
    }

}